import { render } from "./SelectModal.vue?vue&type=template&id=6959e380&scoped=true"
import script from "./SelectModal.vue?vue&type=script&lang=ts"
export * from "./SelectModal.vue?vue&type=script&lang=ts"

import "./SelectModal.vue?vue&type=style&index=0&id=6959e380&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6959e380"

export default script